import React, { useEffect, useRef, useState } from "react";
import { BiMenuAltLeft } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { Tilt } from "react-tilt";
import { useNavigate, useLocation } from "react-router-dom";
import useSound from "use-sound";

const hoverSound = "https://res.cloudinary.com/dwbshru0j/video/upload/v1787588734/Portfolio%20Website/Others/hover_umw7br.wav";
const clickSound = "https://res.cloudinary.com/dwbshru0j/video/upload/v1787588732/Portfolio%20Website/Others/click_cehgph.mp3";

const Menu1 = [
  {
    option: "Blogs",
    link: "/blogs",
    // banner: missionsBanner,
    caption: "Latest notes, experiments, and build logs"
  },
  {
    option: "Email",
    href: "mailto:divyaagrawal0747@gmail.com",
    // banner: missionsBanner,
    caption: "Drop a quick message directly"
  },
  {
    option: "Testimonials",
    link: "/testimonials",
    // banner: missionsBanner,
    caption: "Words from collaborators and teams"
  },
  {
    option: "Let's Talk",
    link: "/contact",
    // banner: missionsBanner,
    caption: "Start a project conversation"
  }
]

const Menu2 = [{
  option: "Report (Resume)",
  link: "https://drive.google.com/file/d/1Kj-LryO_epq88FtL0kTfOvUpOLs27ASW/view?usp=drive_link",
  banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787584790/Portfolio%20Website/Hover%20Thumbs/thumb_resume_ug40w9.webp",
  caption: "Experience snapshot and highlights"
},
{
  option: "LinkedIn",
  link: "https://www.linkedin.com/in/divya--agrawal/",
  banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787584792/Portfolio%20Website/Hover%20Thumbs/thumb_linkedin_lo47fo.webp",
  caption: "Professional profile and network"
},
{
  option: "GitHub",
  link: "https://www.github.com/divyaagrawal261",
  banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787584798/Portfolio%20Website/Hover%20Thumbs/thumb_github_xarkyp.webp",
  caption: "Code repositories and open-source work"
},
{
  option: "LeetCode",
  link: "https://leetcode.com/u/divyaagrawal261/",
  banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787584795/Portfolio%20Website/Hover%20Thumbs/thumb_leetcode_gemriw.webp",
  caption: "Problem-solving profile"
}]

const MainMenu = [
  {
    option: "Dashboard",
    altText: "Home",
    link: "/",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787558982/Portfolio%20Website/Hover%20Thumbs/thumb_home_c7btn9.webp",
    caption: "Return to the main dashboard"
  },
  {
    option: "Tools",
    altText: "TechStack",
    link: "/tools",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787559396/Portfolio%20Website/Hover%20Thumbs/thumb_tools_ibsf7v.avif",
    caption: "Explore your toolkit and stack"
  },
  {
    option: "Missions",
    altText: "Experience",
    link: "/experience",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787559376/Portfolio%20Website/Hover%20Thumbs/thumb_missions_ayxxt9.avif",
    caption: "Journey across experience milestones"
  },
  {
    option: "Projects",
    altText: "Learnings",
    link: "/projects",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787559396/Portfolio%20Website/Hover%20Thumbs/thumb_projects_sbtbrv.avif",
    caption: "See featured builds and case studies"
  },
  {
    option: "Audio",
    altText: "Sound FX",
    action: "toggleAudio",
    banner: null,
    caption: "Toggle hover and click sound effects"
  },
  {
    option: "ETCETRA",
    altText: "About Me!",
    link: "/about",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787559376/Portfolio%20Website/Hover%20Thumbs/thumb_about_tf2m8p.avif",
    caption: "Read the story behind this portfolio"
  },
  {
    option: "Lite",
    altText: "Minimal!",
    link: "/portfolio",
    banner: "https://res.cloudinary.com/dwbshru0j/image/upload/v1787559404/Portfolio%20Website/Hover%20Thumbs/thumb_lite_wfar8f.avif",
    caption: "Libraries, assets, and acknowledgements\n"
  },
  // GAME INTEGRATION: Operation Blackout entry point
  // {
  //   option: "CASE FILE",
  //   altText: "Mission",
  //   link: "/game",
  //   banner: null,
  //   caption: "Classified intelligence mission — Operation Blackout",
  // }
]

const FuturisticMenu = ({ audioEnabled, setAudioEnabled, menuOpen, setMenuOpen }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoverTooltip, setHoverTooltip] = useState(null);
  const [scrambleLabels, setScrambleLabels] = useState({});
  const scrambleTimersRef = useRef({});
  const tooltipRef = useRef(null);
  const hasTooltip = Boolean(hoverTooltip);

  const TOOLTIP_OFFSET = 18;
  const TOOLTIP_VIEWPORT_PADDING = 12;
  const TOOLTIP_FALLBACK_WIDTH = 320;
  const TOOLTIP_FALLBACK_HEIGHT = 180;

  const navigate = useNavigate();
  const location = useLocation();

  // pages where certain navbar elements should be hidden
  const hiddenStatePages = ["/portfolio"];
  const isHiddenPage = hiddenStatePages.includes(location.pathname);

  const [playSound] = useSound(hoverSound, { soundEnabled: audioEnabled });
  const [playClickSound] = useSound(clickSound, { soundEnabled: audioEnabled });

  useEffect(() => {
    return () => {
      Object.values(scrambleTimersRef.current).forEach((timerId) => {
        clearInterval(timerId);
      });
    };
  }, []);

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getClampedTooltipPosition = (clientX, clientY) => {
    const rect = tooltipRef.current?.getBoundingClientRect();
    const tooltipWidth = rect?.width || TOOLTIP_FALLBACK_WIDTH;
    const tooltipHeight = rect?.height || TOOLTIP_FALLBACK_HEIGHT;

    const preferredX = clientX + TOOLTIP_OFFSET;
    const preferredY = clientY + TOOLTIP_OFFSET;

    const maxX = Math.max(
      TOOLTIP_VIEWPORT_PADDING,
      window.innerWidth - tooltipWidth - TOOLTIP_VIEWPORT_PADDING
    );
    const maxY = Math.max(
      TOOLTIP_VIEWPORT_PADDING,
      window.innerHeight - tooltipHeight - TOOLTIP_VIEWPORT_PADDING
    );

    return {
      x: clamp(preferredX, TOOLTIP_VIEWPORT_PADDING, maxX),
      y: clamp(preferredY, TOOLTIP_VIEWPORT_PADDING, maxY),
    };
  };

  useEffect(() => {
    if (!hasTooltip) return;

    // Re-clamp after render using real tooltip dimensions.
    const rafId = window.requestAnimationFrame(() => {
      setHoverTooltip((prev) => {
        if (!prev) return prev;

        const { x, y } = getClampedTooltipPosition(prev.clientX, prev.clientY);
        if (prev.x === x && prev.y === y) return prev;

        return {
          ...prev,
          x,
          y,
        };
      });
    });

    return () => window.cancelAnimationFrame(rafId);
  }, [hoverTooltip?.clientX, hoverTooltip?.clientY, hoverTooltip?.title, hoverTooltip?.caption, hoverTooltip?.banner]);

  useEffect(() => {
    if (!hoverTooltip) return;

    const handleViewportChange = () => {
      setHoverTooltip((prev) => {
        if (!prev) return prev;

        const { x, y } = getClampedTooltipPosition(prev.clientX, prev.clientY);
        if (prev.x === x && prev.y === y) return prev;

        return {
          ...prev,
          x,
          y,
        };
      });
    };

    window.addEventListener("resize", handleViewportChange);

    return () => {
      window.removeEventListener("resize", handleViewportChange);
    };
  }, [hasTooltip]);

  const toggleAudioFromMenu = () => {
    setAudioEnabled(!audioEnabled);
  };

  const defaultOptions = {
    reverse: false,
    max: 45,
    perspective: 1500,
    scale: 1.2,
    speed: 1500,
    transition: true,
    reset: true,
  };

  const handleToggle = () => {
    if (audioEnabled) playClickSound();

    if (menuOpen) {
      setIsVisible(false);
      setTimeout(() => setMenuOpen(false), 300);
    } else {
      setMenuOpen(true);
      setTimeout(() => setIsVisible(true), 10);
    }
  };

  const handleNavigate = (path) => {
    if (audioEnabled) playClickSound();
    setIsVisible(false);
    setTimeout(() => {
      setMenuOpen(false);
      navigate(path);
    }, 300);
  };

  const showMenuTooltip = (item, event) => {
    const { x, y } = getClampedTooltipPosition(event.clientX, event.clientY);

    setHoverTooltip({
      title: item.option,
      caption: item.caption,
      banner: item.banner,
      clientX: event.clientX,
      clientY: event.clientY,
      x,
      y,
    });
  };

  const moveMenuTooltip = (event) => {
    setHoverTooltip((prev) => {
      if (!prev) return prev;

      const { x, y } = getClampedTooltipPosition(event.clientX, event.clientY);

      return {
        ...prev,
        clientX: event.clientX,
        clientY: event.clientY,
        x,
        y,
      };
    });
  };

  const clearScrambleTimer = (key) => {
    if (!scrambleTimersRef.current[key]) return;

    clearInterval(scrambleTimersRef.current[key]);
    delete scrambleTimersRef.current[key];
  };

  const scrambleToText = (key, targetText) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let iteration = 0;

    clearScrambleTimer(key);

    scrambleTimersRef.current[key] = setInterval(() => {
      const scrambled = targetText
        .split("")
        .map((char, index) => {
          if (char === " ") return " ";
          if (index < iteration) return targetText[index];
          return letters[Math.floor(Math.random() * letters.length)];
        })
        .join("");

      setScrambleLabels((prev) => ({
        ...prev,
        [key]: scrambled,
      }));

      iteration += 0.4;

      if (iteration >= targetText.length) {
        clearScrambleTimer(key);
        setScrambleLabels((prev) => ({
          ...prev,
          [key]: targetText,
        }));
      }
    }, 20);
  };

  return (
    <>
      {/* MENU TOGGLE */}
      {!isHiddenPage && (
        <div
          onClick={handleToggle}
          className="fixed z-[60] h-fit w-fit m-2 lg:m-4 cursor-pointer hidden md:block"
        >
          <div className="p-2 rounded-full text-2xl border border-white/15 bg-custom-yellow hover:scale-125 transition-all duration-500">
            {!menuOpen ? (
              <BiMenuAltLeft fill="#040303" />
            ) : (
              <IoClose fill="#040303" />
            )}
          </div>
        </div>
      )}

      {/* NAME */}
      {!isHiddenPage && (
        <div className="fixed hidden md:block right-0 lg:right-4 p-4 z-[60]" onClick={() => navigate("/home")}>
          <h1
            className="font-sakana text-xl md:text-2xl lg:text-4xl text-custom-yellow relative overflow-hidden hover:text-center transition-all duration-300 cursor-pointer hover:uppercase hover:font-extrabold px-8"
            style={{
              clipPath: "none",
              transition: "clip-path 0.6s ease-in-out, color 0.3s ease-in-out",
              background: "linear-gradient(90deg, #e48c1e 0%, #e48c1e 100%)",
              backgroundSize: "0% 100%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left center",
              color: "#e48c1e",
            }}
            onMouseEnter={(e) => {
              e.target.style.clipPath =
                "polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%)";
              e.target.style.backgroundSize = "100% 100%";
              e.target.style.color = "#000000";
              e.target.style.transition =
                "clip-path 0.6s ease-in-out, background-size 0.4s ease-in-out, color 0.3s ease-in-out 0.2s";
            }}
            onMouseLeave={(e) => {
              e.target.style.clipPath = "none";
              e.target.style.backgroundSize = "0% 100%";
              e.target.style.color = "#e48c1e";
              e.target.style.transition =
                "clip-path 0.6s ease-in-out, background-size 0.4s ease-in-out, color 0.2s ease-in-out";
            }}
          >
            Divya Agrawal
          </h1>
        </div>
      )}

      {/* MENU OVERLAY */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center menu backdrop-blur-sm bg-gradient-to-br from-black via-black/50 to-custom-yellow/20">
          <style jsx>{`
                @keyframes float {
                  0%, 100% {
                    transform: translateY(0px);
                  }
                  50% {
                    transform: translateY(-10px);
                  }
                }
              `}</style>
          <div className="text-custom-yellow absolute top-16 text-4xl  font-sakana animate-float">NAVIGATOR</div>
          <div className="w-full flex items-center justify-between h-full p-36 text-[#e48c1e] font-sakana text-2xl" style={{ animation: "float 3s ease-in infinite" }}>
            <div className="flex-col">
              <ul>
                {Menu1.map((item) => (
                  <li
                    onMouseEnter={(e) => {
                      if (audioEnabled) playSound();
                      e.currentTarget.style.backgroundSize = "100% 100%";
                      e.currentTarget.style.color = "#000";
                      showMenuTooltip(item, e);
                    }}
                    onMouseMove={moveMenuTooltip}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.clipPath = "none";
                      e.currentTarget.style.backgroundSize = "0% 100%";
                      e.currentTarget.style.color = "#e48c1e";
                      setHoverTooltip(null);
                    }}

                    onClick={() => { (item.link && navigate(item.link)) || (item.href && window.open(item.href, "_blank")) }}
                    className="hover:text-center hover:bg-custom-yellow hover:text-black hover:scale-110 p-2" key={item.option}>
                    {item.option}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex-col">
              <ul>
                {Menu2.map((item) => (
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <li
                      onMouseEnter={(e) => {
                        if (audioEnabled) playSound();
                        e.currentTarget.style.backgroundSize = "100% 100%";
                        e.currentTarget.style.color = "#000";
                        showMenuTooltip(item, e);
                      }}
                      onMouseMove={moveMenuTooltip}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.clipPath = "none";
                        e.currentTarget.style.backgroundSize = "0% 100%";
                        e.currentTarget.style.color = "#e48c1e";
                        setHoverTooltip(null);
                      }}

                      className="hover:text-center hover:bg-custom-yellow hover:text-black hover:scale-110 p-2" key={item.option}>
                      {item.option}
                    </li>
                  </a>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`fixed ${isVisible ? "animate-fadeIn" : "animate-fadeOut"}`}
            style={{
              animation: isVisible ? "float 3s ease-in-out infinite" : "none",
            }}
          >
            <Tilt options={defaultOptions} className="w-72 p-5 text-custom-yellow font-mono">
              <svg
                className="absolute inset-0 w-full h-full z-[-1] pointer-events-none"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
              >
                <polygon
                  points="0,0 12,0 18,6 88,6 94,12 100,18 100,65 94,71 94,100 6,100 0,94 0,55 6,49 6,22 0,16"
                  fill="#040303E5"
                  fillOpacity="0.5"
                  stroke="#e48c1e"
                  strokeWidth="2"
                  vectorEffect="non-scaling-stroke"
                />
              </svg>

              {/* INNER CONTENT */}
              <div
                className="relative p-5 bg-black/50 border border-custom-yellow outline outline-2 outline-custom-yellow rounded-xl shadow-xl transition-all duration-300 futuristic-box"
                style={{
                  clipPath:
                    "polygon(0% 0%, 12% 0%, 18% 6%, 88% 6%, 94% 12%, 100% 18%, 100% 65%, 94% 71%, 94% 100%, 6% 100%, 0% 94%, 0% 55%, 6% 49%, 6% 22%, 0% 16%)",
                }}
              >
                <ul className="space-y-4">
                  {MainMenu.map((item) => {
                    const isAudioOption = item.action === "toggleAudio";
                    const baseLabel = isAudioOption
                      ? `Audio: ${audioEnabled ? "ON" : "OFF"}`
                      : item.option;
                    const renderedLabel = scrambleLabels[item.option] || baseLabel;

                    const accentColor = isAudioOption
                      ? (audioEnabled ? "#00ff00" : "#ff4444")
                      : "#e48c1e";

                    return (
                      <li
                        key={item.option}
                        role="button"
                        tabIndex={0}
                        className="relative overflow-hidden hover:text-center transition-all duration-300 cursor-pointer text-2xl hover:uppercase hover:font-extrabold font-sakana"
                        style={{
                          clipPath: "none",
                          transition:
                            "clip-path 0.6s ease-in-out, color 0.3s ease-in-out",
                          background: `
                          linear-gradient(
                            90deg,
                            ${accentColor} 0%,
                            ${accentColor} 100%
                          )
                        `,
                          backgroundSize: "0% 100%",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "left center",
                          color: accentColor,
                        }}
                        onMouseEnter={(e) => {
                          if (audioEnabled) playSound();
                          e.currentTarget.style.clipPath =
                            "polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%,10% 100%, 0% 50%)";
                          e.currentTarget.style.backgroundSize = "100% 100%";
                          e.currentTarget.style.color = "#000";
                          scrambleToText(item.option, item.altText || baseLabel);
                          showMenuTooltip(
                            {
                              ...item,
                              option: renderedLabel,
                            },
                            e
                          );
                        }}
                        onMouseMove={moveMenuTooltip}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.clipPath = "none";
                          e.currentTarget.style.backgroundSize = "0% 100%";
                          e.currentTarget.style.color = accentColor;
                          scrambleToText(item.option, baseLabel);
                          setHoverTooltip(null);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") e.currentTarget.click();
                        }}
                        onClick={() => {
                          if (isAudioOption) {
                            toggleAudioFromMenu();
                            return;
                          }

                          if (item.link) handleNavigate(item.link);
                        }}
                      >
                        {renderedLabel}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Tilt>
          </div>

          {hoverTooltip && (
            <div
              ref={tooltipRef}
              className="fixed z-[75] w-fit pointer-events-none rounded-md border border-custom-yellow/60 bg-black/90 p-2 shadow-xl"
              style={{
                left: `${hoverTooltip.x}px`,
                top: `${hoverTooltip.y}px`,
              }}
            >
              {hoverTooltip.banner && (
                <img
                  src={hoverTooltip.banner}
                  alt={`${hoverTooltip.title} preview`}
                  className="w-[300px] object-cover rounded-sm border border-custom-yellow/50 mb-2"
                />
              )}
              <p className="max-w-[300px] font-sakana text-wrap text-custom-yellow text-sm font-sans leading-tight">
                {hoverTooltip.caption}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FuturisticMenu;
